import styled from 'styled-components';

export const ProfileMainWrap = styled.div(
  props => `
        .aisProfileWrap{
    padding: 24px 20px 16px 20px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.aisProfileWrap .aisProfielPic{
    border-radius: 4px;
    background: #F6F6F6;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 160px;
    width: 160px;
    background-size: contain;
    background-repeat: no-repeat;
        
    img {
        width: 100%;
        height: 100%;
    }
}

.aisProfileWrap .profileListItem{
    display: flex;
    align-items: center;
    padding: 12px;
    font-size: 14px;
    line-height: 20px;
}

.aisProfileWrap .profileListItem.active{
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: #EAF5FF;
    border: 1px solid #008CFF;
    border-radius: 4px;
}
    `,
);
